module.exports = __webpack_public_path__ + "img/cold-dish.9e74d33f.svg";